import { Checkbox } from "../../Checkbox"
import { ResponsiveSelfAlign } from "../../../../../base/styles"
import { SelectSelfAlign } from "./SelectSelfAlign"
import clsx from "clsx"
import { useState } from "react"

export const EditSelfAlign = ({ title, value, className, onChange }: {
    title: string,
    value: ResponsiveSelfAlign,
    className?: string,
    onChange: (value?: ResponsiveSelfAlign) => void
}) => {
    const [responsive, setResponsive] = useState<boolean>();

    return <div className={clsx(className)}>
        <div className="d-flex align-items-end">
            <SelectSelfAlign
                title={title}
                className="flex-grow-1 pe-2"
                onChange={(newValue) => { onChange({ ...value, allSizes: newValue }) }}
                value={value?.allSizes} />
            <Checkbox
                title="Responsive"
                className="fs-8 fw-semibold"
                value={responsive === true}
                onChange={setResponsive} />
        </div>

        {responsive &&
            <div className="d-flex flex-row flex-wrap mx-5 my-3">
                <SelectSelfAlign
                    title="Small"
                    className="w-50 pe-2"
                    onChange={(newValue) => { onChange({ ...value, small: newValue }) }}
                    value={value?.small} />
                <SelectSelfAlign
                    title="Medium"
                    className="w-50 pe-2"
                    onChange={(newValue) => { onChange({ ...value, medium: newValue }) }}
                    value={value?.medium} />
                <SelectSelfAlign
                    title="Large"
                    className="w-50 pe-2"
                    onChange={(newValue) => { onChange({ ...value, large: newValue }) }}
                    value={value?.large} />
                <SelectSelfAlign
                    title="Ex. Large"
                    className="w-50 pe-2"
                    onChange={(newValue) => { onChange({ ...value, xLarge: newValue }) }}
                    value={value?.xLarge} />
                <SelectSelfAlign
                    title="Ex. Large +"
                    className="w-50 pe-2"
                    onChange={(newValue) => { onChange({ ...value, xxLarge: newValue }) }}
                    value={value?.xxLarge} />
            </div>}
    </div>
}